import { combineReducers } from 'redux';

const allLimitProductListInitialState = {
  list: null,
  loadStatus: 0,
};

const allKillProductListInitialState = {
  list: null,
  loadStatus: 0,
};

const allGroupProductListInitialState = {
  data: null,
  loadStatus: 0,
};

const allOverseaProductListInitialState = {
  list: null,
  loadStatus: 0,
};

const productSearchInitialState = {
  list: null,
  loadStatus: 0,
  query: {
    keyword: '',
    size: 20,
  },
};

const commentMasterInitialState = {
  loadStatus: 0,
  count: 0,
  didLoadAll: false,
  query: {
    size: 20,
  },
};

const pickerInitialState = {
  list: null,
  loadStatus: 0,
  didLoadAll: false,
  query: {
    size: 20,
    keyword: '',
  },
  input: {
    products: [],
  },
};

const detailInitialState = {
  loadStatus: 0,
};

const rgproductListInitialState = {
  loadStatus: 0,
  list: null,
  didLoadAll: false,
  query: {
    size: 20,
  },
};

const randomProductListInitialState = {
  loadStatus: 0,
  list: null,
  didLoadAll: false,
  query: {
    size: 20,
  },
};

const packageProductInitialState = {
  list: null,
  loadStatus: 0,
};

function productsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_PRODUCTS_BY_IDS_COMPLETION':
    case 'LOAD_PACKAGE_PRODUCT_LIST_COMPLETION':
    case 'LOAD_ALL_LIMIT_PRODUCT_LIST_COMPLETION':
    case 'LOAD_ALL_KILL_PRODUCT_LIST_COMPLETION':
    case 'LOAD_ALL_OVERSEA_PRODUCT_LIST_COMPLETION':
    case 'LOAD_OVERSEA_CART_MERGE_PRODUCT_LIST_COMPLETION': {
      const { list, error } = action;

      if (error) {
        return state;
      }

      return list.reduce(
        (obj, product) => {
          obj[product.code] = product;
          return obj;
        },
        { ...state }
      );
    }

    case 'LOAD_RANDOM_GROUP_PRODUCT_LIST_COMPLETION':
    case 'LOAD_RANDOM_PRODUCT_LIST_COMPLETION': {
      const { list, error } = action;

      if (error) {
        return state;
      }

      return list.reduce(
        (nextState, product) => {
          nextState[product.code] = {
            ...nextState[product.code],
            ...product,
          };
          return nextState;
        },
        { ...state }
      );
    }

    case 'LOAD_ALL_GROUP_PRODUCT_LIST_COMPLETION':
    case 'LOAD_KILL_LIST_COMPLETION':
    case 'LOAD_CART_MERGE_PRODUCT_LIST_COMPLETION': {
      const { data, error } = action;

      if (error) {
        return state;
      }

      return (data.listData || []).reduce(
        (obj, product) => {
          obj[product.code] = { ...state[product.code], ...product };
          return obj;
        },
        { ...state }
      );
    }

    case 'LOAD_HOME_GROUP_LIST_COMPLETION':
    case 'LOAD_NEWUSER_PRODUCT_LIST_COMPLETION': {
      const { list, error } = action;

      if (error) {
        return state;
      }

      return (list || []).reduce(
        (obj, product) => {
          obj[product.code] = product;
          return obj;
        },
        { ...state }
      );
    }

    case 'LOAD_HOME_PRODUCT_LIST_COMPLETION': {
      const { list, error } = action;

      if (error) {
        return state;
      }

      return list.reduce(
        (nextState, product) => {
          nextState[product.code] = {
            ...nextState[product.code],
            ...product,
          };
          return nextState;
        },
        { ...state }
      );
    }

    case 'LOAD_PRESALE_LIST_COMPLETION': {
      const { list, error } = action;
      if (error) {
        return state;
      }

      return {
        ...state,
        ...list.reduce((obj, theme) => {
          (theme.products || []).forEach(product => {
            obj[product.code] = product;
          });

          return obj;
        }, {}),
      };
    }

    case 'LOAD_HOME_THEME_LIST_COMPLETION':
    case 'LOAD_WEAPP_HOME_THEME_LIST_COMPLETION': {
      const { data, error } = action;
      if (error) {
        return state;
      }

      const list = (data.tops || []).concat(data.others || []);

      return {
        ...state,
        ...list.reduce((obj, theme) => {
          (theme.products || []).forEach(product => {
            obj[product.code] = product;
          });
          return obj;
        }, {}),
      };
    }

    case 'LOAD_PRODUCT_COMPLETION': {
      const { productId, data, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [productId]: { ...state[productId], ...data },
      };
    }

    case 'ADD_XG_CART_COMPLETION':
    case 'LOAD_XG_PRODUCT_LIMIT_INFO_COMPLETION': {
      const { error, data, productId } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [productId]: {
          ...state[productId],
          xg: data,
        },
      };
    }

    case 'LOAD_CART_SHARE_INFO_COMPLETION': {
      const { data, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        ...(data.listData || []).reduce((obj, item) => {
          obj[item.code] = item.product;
          return obj;
        }, {}),
      };
    }
    case 'LOAD_CART_LIST_COMPLETION': {
      const { list = [], error, cartType } = action;

      if (error) {
        return state;
      }

      if (cartType === 2) {
        return list.reduce(
          (obj, item) => {
            obj[item.code] = {
              ...(obj[item.code] || {}),
              ...item.product,
            };
            return obj;
          },
          { ...state }
        );
      }

      return list.reduce(
        (nextState, { cartVo }) => {
          cartVo.forEach(item => {
            nextState[item.code] = {
              ...(nextState[item.code] || {}),
              ...item.product,
            };
          });
          return nextState;
        },
        { ...state }
      );
    }

    case 'LOAD_CART_ACTIVITY_GIFT_LIST_COMPLETION': {
      const { error, list } = action;

      if (error) {
        return state;
      }

      return list.reduce(
        (nextState, item) => {
          item.list.forEach(product => {
            const { code } = product;
            nextState[code] = {
              ...nextState[code],
              ...product,
            };
          });
          return nextState;
        },
        { ...state }
      );
    }

    case 'LOAD_SSL_DETAIL_WITH_PRODUCT_CODE_COMPLETION': {
      const { productCode, error, data } = action;

      if (error) {
        return state;
      }

      const { product } = data;
      return {
        ...state,
        [productCode]: {
          ...state[productCode],
          ...product,
        },
      };
    }
    case 'LOAD_SSL_DETAIL_WITH_GAME_ID_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return state;
      }

      const { product } = data;
      return {
        ...state,
        [product.code]: {
          ...state[product.code],
          ...product,
        },
      };
    }
    /* case 'LOAD_GROUP_THEME_LIST_COMPLETION': {
      const { error, list } = action;
      if (error) {
        return state
      }

      if (!list || !list.length) {
        return state
      }

      const productsObj = list.reduce((acc, cur) => {
        const { ptProductVos } = cur;
        if (!ptProductVos || !ptProductVos.length) {
          return acc
        }

        ptProductVos.forEach(product => acc[product.code] = product);
        return acc
      }, {})

      return {
        ...state,
        ...productsObj,
      }
    } */
    default:
      return state;
  }
}
function allLimitProductListReducer(
  state = allLimitProductListInitialState,
  action
) {
  switch (action.type) {
    case 'LOAD_ALL_LIMIT_PRODUCT_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_ALL_LIMIT_PRODUCT_LIST_COMPLETION': {
      const { list, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list: list.map(product => product.code),
      };
    }

    default:
      return state;
  }
}
function allKillProductListReducer(
  state = allKillProductListInitialState,
  action
) {
  switch (action.type) {
    case 'LOAD_ALL_KILL_PRODUCT_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_ALL_KILL_PRODUCT_LIST_COMPLETION': {
      const { list, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list: list.map(product => product.code),
      };
    }

    default:
      return state;
  }
}
function allGroupProductListReducer(
  state = allGroupProductListInitialState,
  action
) {
  switch (action.type) {
    case 'LOAD_ALL_GROUP_PRODUCT_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_ALL_GROUP_PRODUCT_LIST_COMPLETION': {
      const { data, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        data: data && {
          topicVo: data.topicVo,
          list: data.listData.map(product => product.code),
        },
      };
    }

    default:
      return state;
  }
}

function allOverseaProductListReducer(
  state = allOverseaProductListInitialState,
  action
) {
  switch (action.type) {
    case 'LOAD_ALL_OVERSEA_PRODUCT_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_ALL_OVERSEA_PRODUCT_LIST_COMPLETION': {
      const { list, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list: list.map(product => product.code),
      };
    }

    default:
      return state;
  }
}

function productSearchReducer(state = productSearchInitialState, action) {
  switch (action.type) {
    case 'LOAD_HOME_PRODUCT_SEARCH_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_HOME_PRODUCT_SEARCH_LIST_COMPLETION': {
      const { error, list } = action;
      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: state.list ? state.list.concat(list) : list,
      };
    }

    default:
      return state;
  }
}

function commentMasterReducer(state = commentMasterInitialState, action) {
  switch (action.type) {
    case 'LOAD_PRODUCT_COMMENT_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
        count: 0,
      };
    }

    case 'LOAD_PRODUCT_COMMENT_LIST_COMPLETION': {
      const { error, list, willReload } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
          list: willReload ? null : state.list,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: willReload ? list : (state.list || []).concat(list),
        count: action.count,
      };
    }

    default:
      return state;
  }
}

function pickerReducer(state = pickerInitialState, action) {
  switch (action.type) {
    case 'LOAD_PRODUCT_PICKER': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_PRODUCT_PICKER_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const list = action.list.map(product => product.code);

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: state.list ? state.list.concat(list) : list,
      };
    }

    case 'INPUT_FOR_PRODUCT_PICKER': {
      return {
        ...state,
        input: {
          ...state.input,
          ...action.input,
        },
      };
    }

    case 'DEINIT_PRODUCT_PICKER': {
      return pickerInitialState;
    }
    default:
      return state;
  }
}

function pickersReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_PRODUCT_PICKER_COMPLETION': {
      if (action.error) {
        return state;
      }

      return action.list.reduce(
        (nextState, product) => {
          nextState[product.code] = product;

          return nextState;
        },
        { ...state }
      );
    }

    default:
      return state;
  }
}

function detailsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_PRODUCT': {
      return {
        ...state,
        [action.productId]: {
          ...(state[action.productId] || detailInitialState),
          loadStatus: 1,
        },
      };
    }

    case 'LOAD_PRODUCT_COMPLETION': {
      return {
        ...state,
        [action.productId]: {
          ...(state[action.productId] || detailInitialState),
          loadStatus: action.error ? 0 : 2,
        },
      };
    }

    default:
      return state;
  }
}

function rgproductListReducer(state = rgproductListInitialState, action) {
  switch (action.type) {
    case 'LOAD_RANDOM_GROUP_PRODUCT_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_RANDOM_GROUP_PRODUCT_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const list = action.list.map(product => product.code);

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: state.list ? state.list.concat(list) : list,
      };
    }

    default:
      return state;
  }
}

function randomProductListReducer(
  state = randomProductListInitialState,
  action
) {
  switch (action.type) {
    case 'LOAD_RANDOM_PRODUCT_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_RANDOM_PRODUCT_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const list = action.list.map(product => product.code);

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: state.list ? state.list.concat(list) : list,
      };
    }

    default:
      return state;
  }
}

function packageProductReducer(state = packageProductInitialState, action) {
  switch (action.type) {
    case 'LOAD_PACKAGE_PRODUCT_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_PACKAGE_PRODUCT_LIST_COMPLETION': {
      const { list, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list: list.map(product => product.code),
      };
    }

    default:
      return state;
  }
}

function cartProductsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_CART_LIST_COMPLETION': {
      const { list = [], error, cartType } = action;

      if (error) {
        return state;
      }

      if (cartType === 2) {
        return list.reduce(
          (obj, item) => {
            obj[item.code] = {
              ...(obj[item.code] || {}),
              ...item.product,
            };
            return obj;
          },
          { ...state }
        );
      }

      return list.reduce(
        (nextState, { cartVo }) => {
          cartVo.forEach(item => {
            nextState[item.code] = {
              ...(nextState[item.code] || {}),
              ...item.product,
            };
          });
          return nextState;
        },
        { ...state }
      );
    }
    default:
      return state;
  }
}

export default combineReducers({
  products: productsReducer,
  details: detailsReducer,
  allLimitProducts: allLimitProductListReducer,
  allKillProducts: allKillProductListReducer,
  allGroupProducts: allGroupProductListReducer,
  allOverseaProducts: allOverseaProductListReducer,
  productSearch: productSearchReducer,
  commentMaster: commentMasterReducer,
  randomGroupProducts: rgproductListReducer,
  randomProducts: randomProductListReducer,
  picker: pickerReducer,
  pickers: pickersReducer,
  packageProduct: packageProductReducer,
  cartProducts: cartProductsReducer,
});
